// extracted by mini-css-extract-plugin
export default {"GlobalErrorScreen":"GlobalErrorScreen-module-aac9846c7bb045de472d"};